export const categories = [
  {
    slug: 'romance',
    name: '恋爱',
    description: '甜蜜浪漫的爱情故事',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20style%20with%20soft%20pink%20warm%20lighting%2C%20dreamy%20atmosphere%2C%20minimalist%20composition%2C%20gentle%20gradient%20background%2C%20romantic%20mood%2C%20Korean%20webtoon%20aesthetic&width=800&height=600&seq=category-romance&orientation=landscape',
    count: 245,
  },
  {
    slug: 'fantasy',
    name: '奇幻',
    description: '魔法与冒险的奇幻世界',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20style%20with%20magical%20warm%20golden%20lighting%2C%20epic%20atmosphere%2C%20minimalist%20composition%2C%20mystical%20gradient%20background%2C%20adventure%20mood%2C%20Korean%20webtoon%20aesthetic&width=800&height=600&seq=category-fantasy&orientation=landscape',
    count: 189,
  },
  {
    slug: 'action',
    name: '动作',
    description: '热血沸腾的战斗场面',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20illustration%20style%20with%20dynamic%20warm%20lighting%2C%20intense%20atmosphere%2C%20minimalist%20composition%2C%20dramatic%20gradient%20background%2C%20powerful%20mood%2C%20Korean%20webtoon%20aesthetic&width=800&height=600&seq=category-action&orientation=landscape',
    count: 156,
  },
  {
    slug: 'suspense',
    name: '悬疑',
    description: '扣人心弦的推理故事',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20illustration%20style%20with%20mysterious%20warm%20lighting%2C%20atmospheric%20composition%2C%20minimalist%20dark%20gradient%20background%2C%20suspenseful%20mood%2C%20Korean%20webtoon%20aesthetic&width=800&height=600&seq=category-suspense&orientation=landscape',
    count: 98,
  },
  {
    slug: 'comedy',
    name: '搞笑',
    description: '轻松搞笑的日常喜剧',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20illustration%20style%20with%20bright%20warm%20lighting%2C%20fun%20atmosphere%2C%20minimalist%20composition%2C%20colorful%20gradient%20background%2C%20humorous%20mood%2C%20Korean%20webtoon%20aesthetic&width=800&height=600&seq=category-comedy&orientation=landscape',
    count: 132,
  },
  {
    slug: 'healing',
    name: '治愈',
    description: '温暖人心的治愈系作品',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20healing%20illustration%20style%20with%20soft%20warm%20natural%20lighting%2C%20peaceful%20atmosphere%2C%20minimalist%20composition%2C%20gentle%20pastel%20gradient%20background%2C%20calm%20mood%2C%20Korean%20webtoon%20aesthetic&width=800&height=600&seq=category-healing&orientation=landscape',
    count: 87,
  },
];